export const ENDPOINT_OPEN_INFO_FIND_ALL = '/api/open-info/list';
export const ENDPOINT_OPEN_INFO_FIND_ONE = '/api/open-info/get-one';
export const ENDPOINT_OPEN_INFO_CREATE_ONE = '/api/open-info/create';
export const ENDPOINT_OPEN_INFO_DELETE_ONE = '/api/open-info/delete';
export const ENDPOINT_OPEN_INFO_UPDATE_ONE = '/api/open-info/update';
